// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".only_93ff {\n  padding: 0.3125rem;\n  margin-left: 1.25rem;\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/MultiSelect/Only.scss","Only.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,yBAAA;ACCJ","file":"Only.scss","sourcesContent":[".only {\n    padding: 0.3125rem;\n    margin-left: 1.25rem;\n    font-size: 0.6875rem;\n    text-transform: uppercase;\n}\n",".only {\n  padding: 0.3125rem;\n  margin-left: 1.25rem;\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n}"]}]);
// Exports
exports.locals = {
	"only": "only_93ff"
};
module.exports = exports;
